/* UNIK - Collection Slider JS */

(function () {
  'use strict';

  class UnikCollectionSlider {
    constructor(section) {
      this.section = section;
      this.cards = [...section.querySelectorAll('.unik-collection-slider__card')];
      this.dots = [...section.querySelectorAll('.unik-collection-slider__dot')];
      this.cardsWrap = section.querySelector('.unik-collection-slider__cards');
      this.overlayId = section.dataset.overlayId;
      this.enablePopup = section.dataset.enablePopup === 'true';

      this._initObserver();
      this._initCards();

      if (this.enablePopup) {
        this.overlay = document.getElementById(this.overlayId);
        if (this.overlay) {
          this.tabs = [...this.overlay.querySelectorAll('.unik-collection-slider-overlay__tab')];
          this.panels = [...this.overlay.querySelectorAll('.unik-collection-slider-overlay__panel')];
          this.closeBtn = this.overlay.querySelector('.unik-collection-slider-overlay__close');
          this._initOverlay();
        }
      }

      this._initMobileSlider();
    }

    /* Scroll-triggered reveal */
    _initObserver() {
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              this.cards.forEach((c) => c.classList.add('is-visible'));
              obs.unobserve(e.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      obs.observe(this.section);
    }

    /* Card click → open overlay at correct tab */
    _initCards() {
      if (!this.enablePopup) return;
      this.cards.forEach((card, i) => {
        card.addEventListener('click', () => this._openOverlay(i));
      });
    }

    /* Overlay logic */
    _initOverlay() {
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this._switchTab(i));
      });

      this.closeBtn.addEventListener('click', () => this._closeOverlay());

      this.overlay.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this._closeOverlay();
      });

      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this._closeOverlay();
      });
    }

    _openOverlay(index) {
      this._switchTab(index);
      this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.closeBtn.focus();
    }

    _closeOverlay() {
      this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    _switchTab(index) {
      const bgColor = this.cards[index]?.dataset.bg || '#fff';
      const textColor = this.cards[index]?.dataset.text || '#000';

      this.overlay.style.backgroundColor = bgColor;
      this.overlay.style.color = textColor;

      this.tabs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        if (i === index) {
          t.style.backgroundColor = textColor;
          t.style.color = bgColor;
          t.style.borderColor = textColor;
        } else {
          t.style.backgroundColor = 'transparent';
          t.style.color = textColor;
          t.style.borderColor = textColor;
        }
      });

      const panelBg = this.cards[index]?.dataset.panelBg || bgColor;
      this.panels.forEach((p, i) => {
        p.classList.toggle('is-active', i === index);
        if (i === index) {
          p.style.backgroundColor = panelBg;
        }
      });

      /* Update CTA button styling */
      const activeBtns = this.panels[index]?.querySelectorAll('.unik-collection-slider-overlay__btn');
      activeBtns?.forEach((btn) => {
        btn.style.color = textColor;
        btn.style.borderColor = textColor;
      });
    }

    /* Mobile horizontal scroll */
    _initMobileSlider() {
      if (!this.cardsWrap || this.dots.length === 0) return;

      this.cardsWrap.addEventListener('scroll', () => {
        const scrollLeft = this.cardsWrap.scrollLeft;
        const card = this.cardsWrap.querySelector('.unik-collection-slider__card');
        if (!card) return;
        const cardW = card.offsetWidth + 12;
        const active = Math.round(scrollLeft / cardW);

        this.dots.forEach((d, i) => {
          d.classList.toggle('is-active', i === active);
          if (i === active) {
            d.style.backgroundColor = this.cards[i]?.dataset.bg || '#000';
          } else {
            d.style.backgroundColor = 'rgba(0,0,0,0.15)';
          }
        });
      });

      /* Set initial dot colors */
      this.dots.forEach((d, i) => {
        if (i === 0) {
          d.style.backgroundColor = this.cards[0]?.dataset.bg || '#000';
        } else {
          d.style.backgroundColor = 'rgba(0,0,0,0.15)';
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.unik-collection-slider').forEach((s) => {
      new UnikCollectionSlider(s);
    });
  });
})();
